<template>
	<div class="d-flex flex-column h-100" style="min-height: 100vh">
		<header class="container-fluid px-0">
			<HeaderGP />
		</header>

		<main class="container-fluid px-0">
			<router-view />
		</main>

		<footer class="container-fluid px-0 py-md-3 pt-3 bg-light mt-auto">
			<FooterGP />

			<ChatIconGp />
		</footer>
	</div>
</template>

<script>
import ApiRequest from "@/http/ApiRequest";
import { localStorageGet } from "@/core/localStorage";
import HeaderGP from "@/components/websites/get-parts/parts/Header.vue";
import FooterGP from "@/components/websites/get-parts/parts/FooterGP.vue";
import ChatIconGp from "@/components/websites/get-parts/parts/ChatIconGP.vue";
import { mapGetters } from "vuex";

export default {
	name: "DefaultLayout",

	components: {
		ChatIconGp,
		FooterGP,
		HeaderGP,
	},

	computed: {
		...mapGetters(["carPartsPromotionCarParts"]),
	},

	data() {
		return {
			companyKey: "get-parts",
		};
	},

	watch: {
		$route: {
			async handler(route) {
				if (route.name === "home" && !route.params.locale) {
					let defaultLocale =
						window.localStorage.getItem("locale") ||
						this.menuCompanyDefaultLocale ||
						"ka";

					window.localStorage.setItem("locale", defaultLocale);
					this.$store.commit("setLocale", defaultLocale);

					await this.$router.push({
						name: "home-locale",
						params: {
							locale: defaultLocale,
						},
					});
				}

				let navbarCollapse = document.getElementById("offcanvasNavbar");
				let offcanvasBackdrop = document.querySelector(".offcanvas-backdrop");

				if (navbarCollapse) {
					navbarCollapse.classList.remove("show");
					navbarCollapse.removeAttribute("aria-modal");
					navbarCollapse.removeAttribute("role");
					document.body.style.overflow = "auto";

					if (offcanvasBackdrop) {
						offcanvasBackdrop.remove();
					}
				}

				// window.scrollTo(0, 0)
			},

			immediate: true,
		},
	},

	created() {
		let locale =
			window.localStorage.getItem("locale") ||
			this.menuCompanyDefaultLocale ||
			"ka";

		this.$store.commit("setLocale", locale);
		window.localStorage.setItem("locale", locale);

		this.getCompany();
		this.getCompanyCategories();
		this.getCompanyMarks();
		this.getPromotionCarParts();
        this.getDiscountedCarParts();
		this.getPopularMarks();
		this.getCompanyAvailableLocales();

		this.getShoppingCart();
		this.getFavorites();

		this.getExchangeRates();
	},

	methods: {
		getCompany() {
			new ApiRequest(
				"company/get",
				{
					key: this.companyKey,
				},
				(data) => {
					if (!data.success) {
						alert(data.message || "Something went wrong while getting company");
						return;
					}

					this.$store.commit("setCompany", data.data);
					this.getCompanyRequisites();
				}
			);
		},

		getCompanyRequisites() {
			new ApiRequest(
				"car-parts/requisites",
				{
					key: this.companyKey,
				},
				(data) => {
					if (!data.data) {
						alert(data.message || "Not found");
						return;
					}

					this.$store.commit("setRequisites", data.data);
				}
			);
		},

		getCompanyCategories() {
			new ApiRequest(
				"car-parts/categories",
				{
					key: this.companyKey,
				},
				(data) => {
					if (!data.success) {
						alert(
							data.message ||
								"Something went wrong while getting company categories"
						);
						return;
					}

					this.$store.commit("setCarPartsCategories", data.data);
					this.$store.dispatch("transformCarPartsCategories");
				}
			);
		},

		getCompanyMarks() {
			new ApiRequest(
				"car-parts/marks",
				{
					key: this.companyKey,
				},
				(data) => {
					if (!data.success) {
						alert(
							data.message ||
								"Something went wrong while getting company categories"
						);
						return;
					}

					this.$store.commit("setCarPartsMarks", data.data);
				}
			);
		},

		getPromotionCarParts() {
			new ApiRequest(
				"car-parts/promotions",
				{
					key: this.companyKey,
				},
				(data) => {
					if (!data.success) {
						alert(
							data.message ||
								"Something went wrong while getting promotion car parts"
						);
						return;
					}

					this.$store.commit("setCarPartPromotionCarPartsLoaded", true);
					this.$store.commit("setCarPartsPromotionCarParts", data.data);
				}
			);
		},

        getDiscountedCarParts() {
            new ApiRequest(
				"car-parts/discounted",
				{
					key: this.companyKey,
				},
				(data) => {
					if (!data.success) {
						alert(
							data.message ||
								"Something went wrong while getting promotion car parts"
						);
						return;
					}

					this.$store.commit("setCarPartsDiscountedCarParts", data.data);
				}
			);
        },

		getCompanyAvailableLocales(companyId) {
			new ApiRequest("menu/company/locales/get", { companyId }, (data) => {
				this.$store.commit("setAvailableLocales", data.data);
			});
		},

		getPopularMarks() {
			new ApiRequest(
				"car-parts/popular-marks",
				{
					key: this.companyKey,
				},
				(data) => {
					if (!data.success) {
						alert(
							data.message || "Something went wrong while getting popular marks"
						);
						return;
					}

					this.$store.commit("setCarPartPopularMarks", data.data);
					this.$store.commit("setCarPartPopularMarksLoaded", true);
				}
			);
		},

		getCompanySettings(companyId) {
			new ApiRequest(
				"menu/company/settings/get",
				{
					keys: [
						"VAT",
						"SERVICE_NAME",
						"CURRENCY",
						"LOCALE",
						"SITE_MAIN_COLOR",
					],
					companyId,
				},
				(data) => {
					if (!data.data) {
						alert(data.message || "Not found");
						return;
					}

					this.$store.commit("setMenuCompanySettings", data.data);
				}
			);
		},

		getShoppingCart() {
			let shoppingCart = localStorageGet("shoppingCart", null);

			if (shoppingCart) {
				shoppingCart = JSON.parse(shoppingCart);
				this.$store.commit("setShoppingCart", shoppingCart);
			}
		},

		getFavorites() {
			let favorites = localStorageGet("favorites", null);

			if (favorites) {
				favorites = JSON.parse(favorites);
				this.$store.commit("setFavorites", favorites);
			}
		},

		getExchangeRates() {
			fetch(
				"https://v6.exchangerate-api.com/v6/dd41d08b900fdbc6fa4115f9/latest/GEL"
			)
				.then((response) => response.json())
				.then((data) => {
					if (data.result !== "success" || !data.conversion_rates) {
						alert(
							data.message ||
								"Something went wrong while getting exchange rates"
						);
						return;
					}

					this.$store.commit("setExchangeRates", data.conversion_rates || {});
				});
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/websites/get-parts/scss/app";
</style>
